import { useCallback, useEffect, useRef } from "react";

const useTimeout = (callback: () => void, delay: number, when = true) => {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef<number>();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const set = useCallback(() => {
    timeoutRef.current = window.setTimeout(() => callbackRef.current(), delay);
  }, [delay]);

  const clear = useCallback(() => {
    timeoutRef.current && window.clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    if (when) {
      set();
    }
    return clear;
  }, [delay, set, clear, when]);

  const reset = useCallback(() => {
    clear();
    set();
  }, [clear, set]);

  return { reset, clear };
};

export default useTimeout;
